module.exports = __webpack_public_path__ + "static/media/regexile.9cdf9925.jpg";